/** Marketing pages that carry the site-wide setup-chat launcher. The landing
 *  ("/") is deliberately absent — it embeds the chat as its hero via
 *  PreauthChatDock, and mounting both would double the widget. Read by the
 *  widget (components/onboarding/preauth-onboarding.tsx) and by its
 *  experiment's `paths` (lib/experiments/registry.ts), so the marketing-cache
 *  bypass covers exactly the pages the widget can show up on. */
export const WIDGET_PATH_PREFIXES: readonly string[] = ["/pricing", "/integrations", "/about", "/blog"];
